"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ColorPicker = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ColorPicker, _Component);

  var _super = _createSuper(ColorPicker);

  function ColorPicker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ColorPicker);
    _this = _super.call(this, props);
    _this.state = {
      value: props.value
    };
    _this.onColorChange = _this.onColorChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onTextChange = _this.onTextChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ColorPicker, [{
    key: "onTextChange",
    value: function onTextChange(e) {
      this.setState({
        value: e.target.value
      });
    }
  }, {
    key: "onColorChange",
    value: function onColorChange(e) {
      this.setState({
        value: e.target.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.state.value;
      return (0, _preact.h)("div", {
        className: "ranks-color-picker-input-wrapper"
      }, (0, _preact.h)("input", {
        type: "text",
        id: "rank_rankStyling_color",
        name: "rank[rankStyling][color]",
        value: value,
        onChange: this.onTextChange,
        className: (0, _classnames.default)('form-control', 'js-checkbox-toggled', 'rank-color-text')
      }), (0, _preact.h)("input", {
        className: (0, _classnames.default)('form-control', 'js-checkbox-toggled', 'rank-color-picker'),
        type: "color",
        value: value,
        onChange: this.onColorChange
      }));
    }
  }]);
  return ColorPicker;
}(_preact.Component);

exports.default = ColorPicker;